import {useEffect} from 'react'
import {useSelector, shallowEqual} from 'react-redux'
import actions from 'redux-auto'

const loadingSelector = state => state.dashboardAzubi.isLoading
const nachweiseSelector = state => state.dashboardAzubi.nachweise
const praxisaufgabenSelector = state => state.dashboardAzubi.praxisaufgaben
const wissensportalSelector = state => state.dashboardAzubi.wissensportal
const ausbildungssplanSelector = state => state.dashboardAzubi.ausbildungsplan
const versetzungsplanSelector = state => state.versetzungsplan.versetzungsplaene
const versetzungsplanIsLoadingSelector = state => state.versetzungsplan.isLoading

export default function useAzubiDashboardData() {
  const isLoading = useSelector(loadingSelector)
  const isLoadingVersetzungsplaene = useSelector(versetzungsplanIsLoadingSelector)
  const nachweise = useSelector(nachweiseSelector, shallowEqual) || {}
  const praxisaufgaben = useSelector(praxisaufgabenSelector, shallowEqual) || {}
  const wissensportal = useSelector(wissensportalSelector, shallowEqual) || {}
  const ausbildungsplan = useSelector(ausbildungssplanSelector, shallowEqual) || {}
  const versetzungsplaene = useSelector(versetzungsplanSelector, shallowEqual) || []

  useEffect(() => {
    actions.dashboardAzubi.getDashboardAzubiData()
    actions.versetzungsplan.readVersetzungsplan()
    actions.versetzungsplan.readVersetzungsplanTermine()
  }, [])

  return {
    nachweise,
    praxisaufgaben,
    wissensportal,
    ausbildungsplan,
    versetzungsplaene,
    isLoadingVersetzungsplaene,
    isLoading,
  }
}
